// extracted by mini-css-extract-plugin
export default {"concerts":"zZfViRkyDWBw_pVHUukw"};